var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62753 12.0031H10.4893V12.5031H1.62753C1.36405 12.5031 1.14042 12.4267 0.948044 12.2758C0.755416 12.1246 0.680469 11.9684 0.680469 11.8031V2.95813H1.42753V11.8031V12.0031H1.62753ZM3.72165 10.0031V10.2031H3.92165H12.3334H12.5334V10.0031V1.60313V1.40313H12.3334H3.92165H3.72165V1.60313V10.0031ZM3.92165 10.7031C3.65817 10.7031 3.43454 10.6267 3.24216 10.4758C3.04953 10.3246 2.97459 10.1684 2.97459 10.0031V1.60313C2.97459 1.43785 3.04953 1.28161 3.24216 1.13047C3.43454 0.979527 3.65817 0.903125 3.92165 0.903125H12.3334C12.5969 0.903125 12.8205 0.979527 13.0129 1.13047C13.2055 1.28161 13.2805 1.43785 13.2805 1.60313V10.0031C13.2805 10.1684 13.2055 10.3246 13.0129 10.4758C12.8205 10.6267 12.5969 10.7031 12.3334 10.7031H3.92165Z",
    fill: "#0A0808",
    stroke: "black",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a05641c31eb9bc00d1c5d14c4e0e3486.svg";
export { ForwardRef as ReactComponent };